import { create } from 'zustand';

export interface Sticks {
  roll: number;
  pitch: number;
  yaw: number;
  throttle: number;
}

const ZERO: Sticks = { roll: 0, pitch: 0, yaw: 0, throttle: 0 };

/**
 * UI mirror of the manual-control session. `useManualControl` is the single
 * writer; panels read this to show the dead-man state and live stick values.
 * Never persisted — a reload always comes back disengaged (the Hub-side
 * watchdog has already BRAKEd the drone by then anyway).
 */
interface ManualSessionStore {
  engaged: boolean;
  sticks: Sticks;
  setEngaged: (on: boolean) => void;
  setSticks: (s: Sticks) => void;
}

export const useManualSession = create<ManualSessionStore>((set) => ({
  engaged: false,
  sticks: ZERO,
  setEngaged: (engaged) => set(engaged ? { engaged } : { engaged, sticks: ZERO }),
  setSticks: (sticks) => set({ sticks }),
}));
